<script setup lang="ts">
const props = defineProps({
  gasFees: {
    type: Number,
    required: true,
  },
  covered: {
    type: Boolean,
    required: true,
  },
  reason: {
    type: String as PropType<string | null>,
    required: false,
    default: null,
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
});

const GFALExStore = useGFALExStore();

const text = computed(() => {
  if (props.reason) return `main.gasFees.${props.reason}`;

  return props.covered ? "main.gasFees.tempCoveredBy" : "";
});
</script>

<template>
  <div class="flex flex-col items-start justify-between">
    <div
      class="w-full flex justify-between items-center gap-2 text-neutral-300">
      <p>
        {{ $t("main.gasFees.transactionFees") }}
      </p>
      <LoaderSpinner v-if="isLoading" size="sm" class="h-6" />
      <p v-else class="font-bold">
        <span :class="covered ? 'line-through' : null">
          {{ roundNum(gasFees, 2) }}
        </span>
        GFAL
      </p>
    </div>
    <div
      class="flex w-full h-4 text-xs"
      :class="covered ? 'justify-between' : 'justify-end'">
      <p v-if="covered" class="text-secondary-200">
        {{ $t(text) }}
      </p>
      <p v-if="!isLoading" class="text-secondary-200 text-right">
        ~
        <span :class="covered ? 'line-through' : null"
          >{{ roundNum(gasFees * GFALExStore.GFALExRate, 2) }}
        </span>
        USD
      </p>
    </div>
  </div>
</template>
